import { Fragment, useCallback } from 'react';

import Column from 'bloko/blocks/column';
import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import { ActStatus, setStatuses } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Reports/ActsReport/Filter/SelectStatus/SelectStatus.less';

const SelectStatus = () => {
    const statuses = useSelector((state) => state.acts.statuses);

    const dispatch = useDispatch();

    const trl = useTrls();

    const STATUSES_SHORT_TEXT = {
        [ActStatus.All]: trl('admin.actsReport.statuses.all'),
        [ActStatus.New]: trl('admin.actsReport.statuses.new'),
        [ActStatus.ReadyTo1C]: trl('admin.actsReport.statuses.ready'),
        [ActStatus.Waiting1C]: trl('admin.actsReport.statuses.wait'),
        [ActStatus.Finished]: trl('admin.actsReport.statuses.finish'),
        [ActStatus.SendingTo1C]: trl('admin.actsReport.statuses.sending'),
        [ActStatus.SentTo1C]: trl('admin.actsReport.statuses.sent'),
        [ActStatus.Error]: trl('admin.actsReport.statuses.error'),
        [ActStatus.Verified]: trl('admin.actsReport.statuses.verified'),
        [ActStatus.VerifiedError]: trl('admin.actsReport.statuses.verifiedError'),
    };

    const STATUSES_TEXT = {
        [ActStatus.New]: `${trl('admin.actsReport.statuses.new')} - ${trl('admin.actsReport.statuses.new.text')}`,
        [ActStatus.ReadyTo1C]: `${trl('admin.actsReport.statuses.ready')} - ${trl(
            'admin.actsReport.statuses.ready.text'
        )}`,
        [ActStatus.Waiting1C]: `${trl('admin.actsReport.statuses.wait')} - ${trl(
            'admin.actsReport.statuses.wait.text'
        )}`,
        [ActStatus.Finished]: `${trl('admin.actsReport.statuses.finish')} - ${trl(
            'admin.actsReport.statuses.finish.text'
        )}`,
        [ActStatus.SendingTo1C]: `${trl('admin.actsReport.statuses.sending')} - ${trl(
            'admin.actsReport.statuses.sending.text'
        )}`,
        [ActStatus.SentTo1C]: `${trl('admin.actsReport.statuses.sent')} - ${trl(
            'admin.actsReport.statuses.sent.text'
        )}`,
        [ActStatus.Error]: `${trl('admin.actsReport.statuses.error')} - ${trl('admin.actsReport.statuses.error.text')}`,
        [ActStatus.Verified]: `${trl('admin.actsReport.statuses.verified')} - ${trl(
            'admin.actsReport.statuses.verified.text'
        )}`,
        [ActStatus.VerifiedError]: `${trl('admin.actsReport.statuses.verifiedError')} - ${trl(
            'admin.actsReport.statuses.verifiedError.text'
        )}`,
    };

    const onChange = useCallback(
        (event) => {
            dispatch(setStatuses(event.target.value));
        },
        [dispatch]
    );
    return (
        <Fragment>
            <FormSpacer>
                <Column xs="2" s="2" m="2" l="2" container>
                    <Select value={statuses} onChange={onChange}>
                        {Object.entries(STATUSES_SHORT_TEXT).map(([key, value]) => (
                            <Option key={key} value={key}>
                                {value}
                            </Option>
                        ))}
                    </Select>
                </Column>
            </FormSpacer>
            <FormSpacer>
                <HoverTip
                    placement={TipPlacement.Top}
                    render={() => (
                        <div>
                            {Object.entries(STATUSES_TEXT).map(([key, value]) => (
                                <p className="select-status__text" key={key}>
                                    {value}
                                </p>
                            ))}
                        </div>
                    )}
                    host={document.body}
                    DropElement={Tip}
                >
                    <Icon view={IconView.Info} initial={IconColor.Blue60} scale={IconScale.Small} />
                </HoverTip>
            </FormSpacer>
        </Fragment>
    );
};

export default SelectStatus;
